export const OrderProductionTableFiltererData = [
    {
        "idFromColumnFilter": "number",
        "id": "number",
        "filterFn": (value, filterValue) => value === null ? "не занумерован".includes(filterValue.toLowerCase()) : value.toLowerCase().includes(filterValue.toLowerCase())
    },
    {
        "idFromColumnFilter": "customerName",
        "id": "customerName",
    },
    {
        "idFromColumnFilter": "header",
        "id": "header",
    },
    {
        "idFromColumnFilter": "state",
        "id": "state"
    },
    {
        "idFromColumnFilter": "models",
        "id": "estimate",
        "field": "modules",
        "filterFn": (value, filterValue) => {
            const names = (value || []).map((module) => module.originalName).filter(Boolean)
            const needle = String(filterValue ?? '').toLowerCase()
            return names.some((name) => name === filterValue || name.toLowerCase().includes(needle))
        }
    },
    {
        "idFromColumnFilter": "dateOfPlannedProduction",
        "id": "dateOfPlannedProduction",
        "filterFn": (value, filterValue) => new Date(value).toLocaleDateString("en-GB").includes(filterValue)
    },

    {
        "idFromColumnFilter": "packagingPercentage",
        "id": "estimate", "field": "packagingPercentage",
    },
    {
        "idFromColumnFilter": "issuePercentage",
        "id": "estimate", "field": "issuePercentage",
    },
]